module.exports = __webpack_public_path__ + "static/media/parachute.775066b6.png";